// extracted by mini-css-extract-plugin
module.exports =  {"root":"ThreeDots-module__root--psABd","dot":"ThreeDots-module__dot--Nl2QH","grow":"ThreeDots-module__grow--tvdcG"};